import { takeEvery, put, call } from "redux-saga/effects"
import jwtDecode from "jwt-decode"
// Login Redux States
import { LOGIN_USER, LOGOUT_USER } from "./actionTypes"
import {
  loginSuccess,
  // logoutUserSuccess,
  apiError,
  showLoading,
  hideLoading,
} from "./actions"

//Include Both Helper File with needed methods
import { postLogin } from "../../../helpers/backend_helper"

function* loginUser({ payload: { user, history } }) {
  try {
    yield put(showLoading(true))
    const response = yield call(postLogin, {
      workEmail: user.workEmail,
      password: user.password,
    })
    const { permissions } = jwtDecode(response.token)
console.log('Token permissions:', permissions)
console.log('Result permissions:', response.result.permissions)
    // localStorage.setItem("authUser", JSON.stringify(response))
    localStorage.setItem("authUser", JSON.stringify({
      ...response,
      result: {
        ...response.result,
        permissions  // ← overwrite permissions from token, not from result
      }
    }))
    // localStorage.setItem("usedImpOrder", response.result.usedImpOrder)

    yield put(loginSuccess(response))
    yield put(hideLoading(false))
    history.push("/dashboard")
  } catch (error) {
    const errorMessage = [error.response.data.error]
    yield put(apiError(errorMessage))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    localStorage.removeItem("usedImpOrder")
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
